export { AgendaDoMural } from './agenda-do-mural.component'
export * from './tipo-da-agenda-do-mural.enum'
export * from './agenda-do-mural.props'
